import CrossIcon from "@atlaskit/icon/core/cross";
import {AsideSidebarPanel} from "~/components/ottopilotDataViewer/rowEngagementPanel";
import {WorkspaceCreateFormGrid} from "~/components/pageScaffolds/workspacePageScaffold/bottomNav/workspaceCreateFormGrid";
import type {WorkspaceMobileBottomCreateItem} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceMobileBottomCreateItem";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {AnankeIconButton} from "@vesta/ananke/components/anankeIconButton";

/**
 * Desktop list-card "Create" panel: same shortcuts as the mobile bottom sheet,
 * shown in the workspace aside column with icon + label rows.
 */
export function WorkspaceListCardCreateSidePanel({
    workspaceId,
    items,
    onClose,
    onBeforeNavigate,
}: {
    workspaceId: Uuid;
    items: readonly WorkspaceMobileBottomCreateItem[];
    onClose: () => void;
    onBeforeNavigate?: () => void;
}) {
    return (
        <AsideSidebarPanel
            headerLeft="Create"
            headerRight={
                <AnankeIconButton
                    type="button"
                    appearance="subtle"
                    icon={CrossIcon}
                    label="Close"
                    onClick={onClose}
                />
            }
            body={
                <WorkspaceCreateFormGrid
                    workspaceId={workspaceId}
                    items={items}
                    variant="sidebar"
                    onNavigate={onClose}
                    onBeforeNavigate={onBeforeNavigate}
                />
            }
        />
    );
}
